import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { User } from "../../models/user";
import { UserAtWork } from "../../models/userAtWork";
import { HttpClient, HttpParams } from "@angular/common/http";
import { NotificationProvider } from "../../providers/notification/notification";
import { PlatformLocation } from "@angular/common";
import { Storage } from "@ionic/storage";
import { App } from "ionic-angular";
import { CompanyProvider } from "../company/company";


@Injectable()
export class ApiProvider {
	apiUrl: string;

	/**
	 * Every function sends HTTP request
	 */
	constructor(public storage: Storage, public http: HttpClient, public notif: NotificationProvider, public platformLocation: PlatformLocation, public app: App, public companyProvider: CompanyProvider) {
		this.apiUrl = environment.clockUrl + '/api/index.php';
	}

	public async handleApiError(error) {
		if (!error) {
			return;
		}
		if (error.error.data && error.error.data.error) {
			this.notif.showErrorMessage(error.error.data.error);
		} else if (error.error.logout) {
			await this.companyProvider.logout();

			await this.app.getActiveNav().setRoot("LoginPage", {}, { animate: true, "direction": "forward" });

			this.notif.showErrorMessage("Uppdatera ditt abonnemang för att använda tjänsten");
		} else if (error.error.invalidSubscription) {
			this.notif.showErrorMessage("Uppdatera ditt abonnemang för att stämpla in enligt schema");
		} else {
			this.notif.showErrorMessage("Ett fel uppstod, var god försök igen. Om felet kvarstår, kontakta support.");
		}
	}

	public async getCompany() {
		return this.storage.get("company");
	}

	public getUsers() {
		return this.http.get(this.apiUrl + "?service=employee&action=getAllActiveEmployees&token=" + this.companyProvider.currentTokenValue());
	}

	public async getCompanyInfo() {
		return this.http.get(this.apiUrl + "?service=company&action=getCompanyInfo&token=" + this.companyProvider.currentTokenValue()).toPromise().then(async (response: any) => {
			await this.storage.get("company").then(async company => {
				await this.companyProvider.setCompany({ ...company, ...response.data.companyInfo });
			});

			return response;
		}, error => {
			this.handleApiError(error);
		});
	}

	public getAllActiveUsersWithTimeregInfo() {
		let usersAtWork: Array<UserAtWork> = [];
		return new Promise((resolve) => {
			this.storage.get("token").then(token => {
				if (token) {
					let url = this.apiUrl + "?service=employee&action=getAllActiveEmployeesWithTimeregInfo&token=" + token;
					this.http.get(url).toPromise().then((response) => {
						if (response["status"] == "ok") {
							let userResult = response["data"];

							for (var i in userResult) {
								console.log(environment.apiUrl);
								userResult[i].pictureUrl = `${environment.apiUrl}/employee/${userResult[i].id}/picture`;

								let useratWork = Object.assign(new UserAtWork(), userResult[i]);
								usersAtWork.push(useratWork);
							}

							resolve(usersAtWork);
						} else {
							if (response["errorCode"] == "NO_CHECKEDIN_EMPLOYEES") {
								this.notif.showInfoMessage("Ingen personal har varit instämplad idag.");
							}

							resolve([]);
						}
					}, error => {
						this.handleApiError(error);
					});
				}
			});
		});
	}

	public async addPersonWhoWantsReport(employeeId: number, civilRegistrationId: string) {
		try {
			const token = await this.storage.get("token");
			if (!token) {
				throw new Error("No token");
			}
			let employeeWhoWantsReport = JSON.stringify({ civilRegistrationId: civilRegistrationId });

			return await this.http.post(this.apiUrl + "?service=report&action=addPersonWhoWantsReport&token=" + token, employeeWhoWantsReport).toPromise();
		} catch (e) {
			this.handleApiError(e);
			throw e;
		}
	}

	public getCompanyMealBenefits() {
		return new Promise((resolve) => {
			this.storage.get("token").then(token => {
				if (token) {
					this.http.get(this.apiUrl + "?service=company&action=getCompanyMealBenefits&token=" + token).toPromise().then((result) => {
						resolve(result);
					});
				}
			}, error => {
				this.handleApiError(error);
			});
		});
	}

	public loginCompany(username, password, recaptchaToken) {
		return this.http.post(this.apiUrl + "?service=login&action=loginCompany", JSON.stringify({
			checkinCompanyId: username,
			password: password,
			recaptchaToken: recaptchaToken
		}));
	}

	public async loginCode(params: any) {
		try {
			const token = this.companyProvider.currentTokenValue();

			const response = await this.http.post(this.apiUrl + "?service=employee&action=login&token=" + token, JSON.stringify(params)).toPromise();
			if (response["status"] == "ok") {
				let data = response["data"];

				if (data.OverlappingFinishedTimereg) {
					return {
						"status": "overlappingFinishedtimeReg",
						"OverlappingFinishedTimeregEndTime": data.OverlappingFinishedTimeregEndTime,
					};
				}

				let user = new User(data.EmployeeId, true, data.FirstName, data.LastName);
				user.pictureUrl = `${environment.apiUrl}/employee/${data.EmployeeId}/picture`;

				// if (user.pictureUrl.indexOf("picture.php") != -1) {
				// 	user.pictureUrl += "&token=" + token;
				// }

				user.workStatus = data.workStatus;
				user.timereg_workplace_id = data.TimeregWorkplaceId;
				user.checkInDate = data.checkInDate;
				user.checkInTime = data.checkInTime;
				user.breaks = data.Breaks;
				user.notifications = data.notifications;
				user.canTakeBreak = data.canTakeBreak;
				user.useScheduleBreak = data.useScheduleBreak;
				user.forceWorkplaceCheckout = data.forceWorkplaceCheckout;

				for (const shift of data.todaysShifts) {
					shift.subtitles = shift.timeStart.substr(0, 5) + " – " + shift.timeEnd.substr(0, 5);
				}

				user.hasPinCode = data.HasPincode;

				user.requireUserPincode = !!(+data.RequireUserPincode);

				user.userLastIdNumbersAsPincode = !!(+data.UserLastIdNumbersAsPincode),

					user.todaysShifts = data.todaysShifts;

				if (data.automaticMealBenefitRegistration == 1) {
					user.automaticMealBenefitRegistration = true;
				}

				if (data.useLunch == 1) {
					user.useLunch = true;
				}

				if (data.useBreakfast == 1) {
					user.useBreakfast = true;
				}

				if (data.Shifts !== null) {
					let shift = data.Shifts;

					let subtitle = shift.timeStart.substr(0, 5) + " – " + shift.timeEnd.substr(0, 5);
					if (shift.breaks != null) {
						subtitle += " (" + shift.breaks + ")";
					}

					let eventData = {
						"color": shift.colorHex,
						"date": shift.date,
						"subtitle": subtitle,
						"title": shift.title
					};
					user.events.push(eventData);
				} else {
					user.events.push({
						"title": "Testing",
						"subtitle": "Some subtitles"
					});
				}

				return {
					status: "success",
					user: user,
					UserLastIdNumbersAsPincode: !!(+data.userLastIdNumbersAsPincode),
					canCheckInAccordingToSchedule: !!(+data.canCheckInAccordingToSchedule),
					canCheckOutAccordingToSchedule: !!(+data.canCheckOutAccordingToSchedule),
					canTakeBreak: (data.canTakeBreak == true),
					breakNotAllowedReason: data.breakNotAllowedReason ? data.breakNotAllowedReason : "",
					message: response["message"],
					errorMessage: response["errorMessage"]
				};
			} else {
				return response;
			}
		} catch (e) {
			console.log("Catching a weird error?", e);

			this.handleApiError(e);
		}
	}

	public async addUser(user: User) {
		const params = new HttpParams({
			fromObject: {
				employeeTypeId: user.employeeType,
				firstname: user.name,
				lastname: user.surname,
				email: user.user_email,
				civilRegistrationNumber: user.civilRegistrationNumber,
				mobileNumber: user.phone,
				addressStreet: user.adress,
				addressPostcode: user.post_number,
				addressCity: user.city
			}
		});

		try {
			const token = await this.storage.get("token");

			if (!token) {
				throw new Error("No token");
			}

			return await this.http.post(this.apiUrl + "?service=employee&action=addEmployee&token=" + token, params).toPromise();
		} catch (e) {
			if (e.status == 422) {
				return e;
			} else {
				this.handleApiError(e);
				throw e;
			}
		}
	}

	public async confirmCheckout(user: User, breaks: Array<{}>) {
		try {
			const token = await this.storage.get("token");
			if (!token) {
				throw new Error("No token");
			}
			let payload = JSON.stringify({
				"employeeId": user.id,
				"adjustedCheckinTime": user.adjustedCheckInDateTime.toLocaleTimeString(), // hh:mm:ss
				"adjustedCheckoutTime": user.adjustedCheckOutDateTime.toLocaleTimeString(), // hh:mm:ss
				"breaks": breaks,
				"regId": user.regId,
				"regIdEnd": user.regIdEnd,
			});

			const response = await this.http.post(this.apiUrl + "?service=checkin&action=confirmCheckout&token=" + token, payload).toPromise();
			let resp;
			let data = response["data"];
			let errors = response["errors"];
			if (errors) {
				resp = { "errors": errors, "requestedActions": data.requestedActions };
			} else {
				user.checkOutDate = data.checkoutDate;
				user.checkOutTime = data.checkoutTime;
				resp = { "user": user, "requestedActions": data.requestedActions };
			}
			return resp;
		} catch (e) {
			this.handleApiError(e);
			throw (e);
		}
	}

	public async updateUserStatus(user: User, newWorkStatus: string, timeType: string = "clock", breakfast: boolean = false, lunch: boolean = false) {
		try {
			const token = await this.storage.get("token");

			if (!token) {
				throw new Error("no token");
			}

			const payload = JSON.stringify({
				breakfast: breakfast,
				timeType: timeType,
				lunch: lunch,
				employeeId: user.id
			});

			let response;

			switch (newWorkStatus) {
				case "not-at-work":
					response = await this.http.post(this.apiUrl + "?service=checkin&action=checkoutUser&token=" + token, payload).toPromise();
					let data = response["data"];
					let errors = response["errors"];
					if (errors) {
						return {
							"status": "failed",
							"errors": errors,
							"requestedActions": data.requestedActions
						};
					} else {
						user.checkOutDate = data.checkoutDate;
						user.checkOutTime = data.checkoutTime;
						user.regId = data.regId;
						user.regIdEnd = data.regIdEnd;
						user.breaks = data.breaks;
						return {
							"status": "success",
							"user": user,
							"requestedActions": data.requestedActions
						};
					}
				case "at-work":
					if (user["workStatus"] == "at-break") {
						response = await this.http.post(this.apiUrl + "?service=checkin&action=endUserBreak&token=" + token, payload).toPromise();
						let data = response["data"];
						let errors = response["errors"];
						if (errors) {
							return {
								"status": "failed",
								"errors": errors,
								"requestedActions": data.requestedActions
							};
						} else {
							return { "status": "success", "user": user };
						}
					} else if (user["workStatus"] == "not-at-work") {
						response = await this.http.post(this.apiUrl + "?service=checkin&action=checkinUser&token=" + token, payload).toPromise();

						const data = response["data"];

						const errors = response["errors"];

						if (errors) {
							return {
								"status": "failed",
								"errors": errors,
								"requestedActions": data.requestedActions
							};
						}

						return {
							"status": "success",
							"user": user,
							"requestedActions": response.data.requestedActions
						};
					} else {
						throw new Error("Invalid workStatus");
					}
				case "at-break":
					response = await this.http.post(this.apiUrl + "?service=checkin&action=beginUserBreak&token=" + token, payload).toPromise();

					return { "status": "success" };
				default:
					throw new Error("invalid status");
			}
		} catch (e) {
			this.handleApiError(e);
			throw e;
		}
	}

	public async prepareCheckout(user: User, timeType: string) {
		try {
			const token = await this.storage.get("token");
			if (!token) {
				throw new Error("No token");
			}

			let payload = JSON.stringify({
				timeType: timeType,
				employeeId: user.id
			});

			const response = await this.http.post(this.apiUrl + "?service=checkin&action=prepareCheckout&token=" + token, payload).toPromise();
			let data = response["data"];
			user.checkInDate = data.checkinDate;
			user.checkInTime = data.checkinTime;
			user.checkOutDate = data.checkoutDate;
			user.checkOutTime = data.checkoutTime;
			user.breaks = data.breaks;

			return { user: user, requestedActions: data.requestedActions };
		} catch (e) {
			this.handleApiError(e);
			throw e;
		}
	}

	/**
	 * addSupportQuestion method
	 *
	 * @param {SupportQuestion} supportQuestion
	 * @returns {Promise<any>}
	 */
	public async addSupportQuestion(supportQuestion: string) {
		/**
		 * Here we send support question
		 * supportQuestion: string
		 *
		 */
		try {
			const token = await this.storage.get("token");
			if (!token) {
				throw new Error("No token");
			}
			return await this.http.post(this.apiUrl + "?service=support&action=addSupportQuestion&token=" + token, JSON.stringify({ question: supportQuestion })).toPromise();
		} catch (e) {
			this.handleApiError(e);
			throw e;
		}
	}

	public async leaveCheckOutComment(user: User, comment: string) {
		try {
			const token = await this.storage.get("token");

			let payload = JSON.stringify({
				"checkOutComment": comment,
				"employeeId": user.id,
				"regId": user["regId"],
				"regIdEnd": user["regIdEnd"],
			});

			const response: any = await this.http.post(this.apiUrl + "?service=checkin&action=leaveCheckOutComment&token=" + token, payload).toPromise();

			let result: any = { "user": user, "requestedActions": response.data.requestedActions };

			if(response.errors !== undefined) {
				result.errors = response.errors;
			}

			return result;
		} catch (e) {
			this.handleApiError(e);
			throw (e);
		}
	}

	public markNotificationAsRead(notificationId: number) {
		return new Promise((resolve) => {
			this.storage.get("token").then(token => {
				if (token) {
					let payload = JSON.stringify({
						"notificationId": notificationId
					});

					this.http.post(this.apiUrl + "?service=notification&action=markNotificationAsRead&token=" + token, payload)
						.toPromise()
						.then(response => {
							resolve(response);
						});
				}
			});
		});
	}

	public markAllNotificationsAsRead(employeeId: number) {
		return new Promise((resolve) => {
			this.storage.get("token").then(token => {
				if (token) {
					let payload = JSON.stringify({
						"employeeId": employeeId
					});

					this.http.post(this.apiUrl + "?service=notification&action=markAllNotificationsAsRead&token=" + token, payload)
						.toPromise()
						.then(response => {
							resolve(response);
						});
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts